import { render, staticRenderFns } from "./stopExpertise.vue?vue&type=template&id=156da4f0&scoped=true"
import script from "./stopExpertise.vue?vue&type=script&lang=js"
export * from "./stopExpertise.vue?vue&type=script&lang=js"
import style0 from "./stopExpertise.vue?vue&type=style&index=0&id=156da4f0&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156da4f0",
  null
  
)

export default component.exports